export default "__VITE_ASSET__DqNSGx_U__"